import { Box, CircularProgress, SxProps, Theme } from "@mui/material";

export interface LoadingSpinnerProps {
  sx?: SxProps<Theme>;
  size?: number;
}

const LoadingSpinner = (props: LoadingSpinnerProps) => {
  const size = props.size || 100;

  return (
    <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", ...props.sx }}>
      <CircularProgress color="primary" size={size} thickness={size / 20} variant="indeterminate" />
    </Box>
  );
};

export default LoadingSpinner;
